import { BaseAjaxService } from './shared/BaseAjaxService.js';
import { PriceCalculator } from './shared/PriceCalculator.js';
import { NotificationManager } from './shared/NotificationManager.js';

export default function builderExtras() {
  const isPresent = document.querySelector('.extra-option-item');
  if (!isPresent) {
    return;
  }

  const elements = {
    extraOptionItems: document.querySelectorAll('.extra-option-item'),
    confirmButton: document.querySelector('[data-confirm-extras]'),
    changeExtrasButton: document.querySelector('[data-change-extras]'),
    body: document.body
  };

  const ajaxService = new BaseAjaxService();
  const priceCalculator = new PriceCalculator();
  const notificationManager = new NotificationManager();

  const extrasConfirmed = ajax_object.extrasConfirmed;

  init();

  function init() {
    fetchAndApplySelectedExtras();
    setupEventListeners();
    setConfirmedState();
  }

  function setupEventListeners() {
    // Extra option items
    elements.extraOptionItems.forEach(item => {
      item.addEventListener('click', () => handleExtraOptionClick(item));
    });

    // Confirm button
    if (elements.confirmButton) {
      elements.confirmButton.addEventListener('click', confirmExtras);
    }

    // Change extras button
    if (elements.changeExtrasButton) {
      elements.changeExtrasButton.addEventListener('click', resetExtrasConfirmation);
    }
  }

  function setConfirmedState() {
    if (extrasConfirmed) {
      elements.body.classList.add('extras-confirmed');
    }
  }

  function handleExtraOptionClick(item) {
    const title = item.getAttribute('data-extra-option-title');
    const price = parseFloat(item.getAttribute('data-extra-option-price')) || 0;

    // Toggle selection
    const isSelected = item.classList.toggle('selected');

    // Update prices
    updateExtrasPrice(price, isSelected);

    // Save selection
    saveExtraOption(title, price, isSelected);
  }

  function updateExtrasPrice(price, isSelected) {
    const currentExtrasTotal = priceCalculator.parsePrice(
      priceCalculator.elements.totalExtras?.textContent
    ) || 0;

    const newExtrasTotal = isSelected ? currentExtrasTotal + price : currentExtrasTotal - price;
    priceCalculator.updateExtrasPrice(newExtrasTotal);

    // Also update the total added price to include extras
    const currentInteriorTotal = priceCalculator.parsePrice(
      priceCalculator.elements.totalAdded?.textContent
    ) || 0;

    // Remove current extras from added total to avoid double counting
    const interiorOnlyTotal = currentInteriorTotal - currentExtrasTotal;

    // Add the new extras total to interior total
    const newAddedTotal = interiorOnlyTotal + newExtrasTotal;
    priceCalculator.updateAddedPrice(newAddedTotal);
  }

  async function saveExtraOption(title, price, isSelected) {
    try {
      await ajaxService.saveExtraOption(title, price, isSelected);
    } catch (error) {
      console.error('Failed to save extra option:', error);
    }
  }

  async function fetchAndApplySelectedExtras() {
    try {
      const response = await ajaxService.getSelectedExtras();
      const selectedExtras = response.selected_extras;

      let totalExtrasPrice = 0;

      Object.values(selectedExtras).forEach(extra => {
        const matchingItem = [...elements.extraOptionItems].find(item =>
          item.getAttribute('data-extra-option-title') === extra.title
        );

        if (matchingItem) {
          matchingItem.classList.add('selected');
          totalExtrasPrice += parseFloat(extra.price) || 0;
        }
      });

      priceCalculator.updateExtrasPrice(totalExtrasPrice);

      // The total added price is already correctly set by PHP on page load
      // No need to modify it here since it already includes both interior and extras

    } catch (error) {
      console.error('Failed to fetch selected extras:', error);
    }
  }

  async function confirmExtras() {
    try {
      const timestamp = new Date().toLocaleString();
      await ajaxService.confirmSelection('extras', timestamp);

      elements.confirmButton.classList.add('confirmed');
      elements.confirmButton.textContent = 'Lisad kinnitatud';
      elements.body.classList.add('extras-confirmed');

      notificationManager.showSuccessMessage('confirmed', 'extras', timestamp);

    } catch (error) {
      console.error('Error confirming extras:', error);
    }
  }

  async function resetExtrasConfirmation() {
    try {
      await ajaxService.resetConfirmation('extras');

      elements.confirmButton.classList.remove('confirmed');
      elements.confirmButton.textContent = 'Kinnita lisad';
      elements.body.classList.remove('extras-confirmed');

      notificationManager.showSuccessMessage('reset', 'extras');

    } catch (error) {
      console.error('Error resetting extras confirmation:', error);
    }
  }
}